import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { CrossFlowProvider } from './lib/CrossFlowProvider';
export { useCrossFlow, withCrossFlow, Journeys, Targets, Reasons } from './index';
var TrelloCrossFlowProvider = function TrelloCrossFlowProvider(props) {
  var redirectToWac = !props.isAaMastered;
  return /*#__PURE__*/React.createElement(CrossFlowProvider, _extends({}, props, {
    originProduct: "trello",
    redirectToWac: redirectToWac
  }));
};
export default TrelloCrossFlowProvider;